import { jsx } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
import { forwardRef } from "react";
const OpenInNewIconInner = (props, ref) => {
  return /* @__PURE__ */ jsx(
    SvgIcon,
    {
      ...props,
      ref,
      children: /* @__PURE__ */ jsx(
        "svg",
        {
          fill: "currentColor",
          height: "48",
          stroke: "currentColor",
          viewBox: "0 -960 960 960",
          width: "48",
          xmlns: "http://www.w3.org/2000/svg",
          children: /* @__PURE__ */ jsx("path", { d: "M197.694-140.001q-23.529 0-40.611-17.082-17.082-17.082-17.082-40.611v-564.612q0-23.529 17.082-40.611 17.082-17.082 40.611-17.082h251.69v45.384h-251.69q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463v564.612q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846h564.612q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463v-251.69h45.384v251.69q0 23.529-17.082 40.611-17.082 17.082-40.611 17.082H197.694Zm186.614-211.692-31.999-32.615 390.307-390.307H530.155v-45.384h289.844v289.844h-45.384V-742L384.308-351.693Z" })
        }
      )
    }
  );
};
const OpenInNewIcon = forwardRef(OpenInNewIconInner);
export {
  OpenInNewIcon
};
